import * as S from './LoadingSpinner.styled'

export const LoadingSpinner = () => {
  return (
    <S.SpinnerContainer>
      <S.SpinnerCircle />
    </S.SpinnerContainer>
  )
}

export default LoadingSpinner
